[
  {
    "name": "Body_18",
    "links": [
      {
        "name": "Relevant information further available for this coil at",
        "linkText": "SKB0112748",
        "url": "https://skb.siemens-healthineers.com/pages/search/Default.aspx?searchtext=SKB0112748",
        "icon": "library",
        "iconSrc": "",
        "iconColor": "black"
      }
    ]
  },
  {
    "name": "Body_30",
    "links": [
      {
        "name": "Relevant information further available for this coil at",
        "linkText": "SKB0112748",
        "url": "https://skb.siemens-healthineers.com/pages/search/Default.aspx?searchtext=SKB0112748",
        "icon": "library",
        "iconSrc": "",
        "iconColor": "black"
      }
    ]
  }
]
